function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Divider, HStack, ModalBody, Slider, SliderFilledTrack, SliderThumb, SliderTrack, Stack, Switch, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import GiveawayModalHeader from './GiveawayModalHeader';
import { GiveawayModalContext } from './GiveawayModalContext';
import { GiveawaySteps } from '@/types/client';
import useGiveawayStore from '@/stores/GiveawayStore';
import SettingsPanel from '../SettingsPanel';
import { useShallow } from 'zustand/react/shallow';
var MIN_MINUTES = 1;
var MAX_MINUTES = 15;
export default function GiveawayActiveStep() {
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(false), 2), isHovering = _React_useState[0], setIsHovering = _React_useState[1];
    var _React_useContext = React.useContext(GiveawayModalContext), onClose = _React_useContext.onClose, setStep = _React_useContext.setStep, onComplete = _React_useContext.onComplete;
    var _useGiveawayStore = useGiveawayStore(useShallow(function(state) {
        return {
            activityTimeout: state.activityTimeout,
            setActivityTimeout: state.setActivityTimeout,
            uniqueWinners: state.uniqueWinners,
            setUniqueWinners: state.setUniqueWinners
        };
    })), setActivityTimeout = _useGiveawayStore.setActivityTimeout, activityTimeout = _useGiveawayStore.activityTimeout, uniqueWinners = _useGiveawayStore.uniqueWinners, setUniqueWinners = _useGiveawayStore.setUniqueWinners;
    return /*#__PURE__*/ _jsxs(ModalBody, {
        padding: 0,
        children: [
            /*#__PURE__*/ _jsx(GiveawayModalHeader, {
                title: intl.formatMessage({
                    id: "S8kqP9",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Conditions"
                        }
                    ]
                }),
                onClose: onClose
            }),
            /*#__PURE__*/ _jsx(Divider, {
                borderColor: "borderSecondary"
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                spacing: 6,
                padding: 6,
                children: [
                    /*#__PURE__*/ _jsx(SettingsPanel, {
                        flexDir: "column",
                        alignItems: "baseline",
                        heading: intl.formatMessage({
                            id: "qfdcYw",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Active Timeout"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "qcEal9",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Only users active within the past "
                                },
                                {
                                    offset: 0,
                                    options: {
                                        one: {
                                            value: [
                                                {
                                                    location: {
                                                        end: {
                                                            column: 59,
                                                            line: 1,
                                                            offset: 58
                                                        },
                                                        start: {
                                                            column: 58,
                                                            line: 1,
                                                            offset: 57
                                                        }
                                                    },
                                                    type: 7
                                                },
                                                {
                                                    type: 0,
                                                    value: " minute"
                                                }
                                            ]
                                        },
                                        other: {
                                            value: [
                                                {
                                                    location: {
                                                        end: {
                                                            column: 76,
                                                            line: 1,
                                                            offset: 75
                                                        },
                                                        start: {
                                                            column: 75,
                                                            line: 1,
                                                            offset: 74
                                                        }
                                                    },
                                                    type: 7
                                                },
                                                {
                                                    type: 0,
                                                    value: " minutes"
                                                }
                                            ]
                                        }
                                    },
                                    pluralType: "cardinal",
                                    type: 6,
                                    value: "minutes"
                                },
                                {
                                    type: 0,
                                    value: " are eligible to win."
                                }
                            ]
                        }, {
                            minutes: activityTimeout
                        }),
                        afterElementContainerProps: {
                            maxWidth: '100%'
                        },
                        afterElement: /*#__PURE__*/ _jsxs(Slider, {
                            onMouseEnter: function() {
                                return setIsHovering(true);
                            },
                            onMouseLeave: function() {
                                return setIsHovering(false);
                            },
                            value: activityTimeout,
                            onChange: function(value) {
                                return setActivityTimeout(Math.max(MIN_MINUTES, value));
                            },
                            colorScheme: "primary",
                            "aria-label": intl.formatMessage({
                                id: "ibQZb3",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Active Timeout Slider"
                                    }
                                ]
                            }),
                            defaultValue: 10,
                            min: MIN_MINUTES - 1,
                            max: MAX_MINUTES,
                            children: [
                                /*#__PURE__*/ _jsx(SliderTrack, {
                                    children: /*#__PURE__*/ _jsx(SliderFilledTrack, {})
                                }),
                                /*#__PURE__*/ _jsx(Tooltip, {
                                    label: activityTimeout,
                                    "aria-label": intl.formatMessage({
                                        id: "fOHivu",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Active Timeout Tooltip"
                                            }
                                        ]
                                    }),
                                    placement: "top",
                                    hasArrow: true,
                                    isOpen: isHovering,
                                    children: /*#__PURE__*/ _jsx(SliderThumb, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(SettingsPanel, {
                        heading: intl.formatMessage({
                            id: "UnFLxJ",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Unique Winners"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "uQ/BeF",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "This will exclude users who have already won this session."
                                }
                            ]
                        }),
                        afterElementContainerProps: {
                            width: 'fit-content'
                        },
                        afterElement: /*#__PURE__*/ _jsx(Switch, {
                            colorScheme: "primary",
                            isChecked: uniqueWinners,
                            onChange: function(e) {
                                return setUniqueWinners(e.target.checked);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Divider, {
                borderColor: "borderSecondary"
            }),
            /*#__PURE__*/ _jsxs(HStack, {
                spacing: 6,
                p: 6,
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        flex: 1,
                        onClick: function() {
                            return setStep(GiveawaySteps.ELIGIBILITY);
                        },
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "cyR7Kh",
                            defaultMessage: "Back"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        flex: 1,
                        variant: "cta",
                        onClick: function() {
                            onClose();
                            onComplete();
                        },
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "JXdbo8",
                            defaultMessage: "Done"
                        })
                    })
                ]
            })
        ]
    });
}
